import { Typography } from "@mui/material";

export default function FailurePayment() {
  return (
    <div>
      <h1>
        <Typography><p style={{alignItem: "center", marginTop: "40px"}}><h4>Tu Pago no se pudo procesar, intente nuevamente.<br/><br/> Muchas Gracias por tu compra</h4></p></Typography>
      </h1>
    </div>
  );
}